import React, {useEffect, useState} from 'react';
import {Form, Input, Select, Switch, Button, Card, Row, Col, Typography, Modal, message, Space, Checkbox} from 'antd';
import {UserOutlined, PhoneOutlined, LockOutlined, MinusOutlined, PlusOutlined} from '@ant-design/icons';
import './Common.module.css';
import styles from './Common.module.css';
import { getXuekeListRequest, updateSchoolTeacherRequest} from "../api";
import { clearAllCookies } from '../../../../util/handleObject';
import Cookies from 'js-cookie';

const { TextArea } = Input;
const EditAccountForm = (props) => {
  const [form] = Form.useForm();
  const [gradeList, setGradeList] = useState([]);
  const [xuekeList, setXuekeList] = useState([]);
  const [teacherList, setTeacherList] = useState([{
    gradeName:"",
    gradeCode:"",
    xuekeName:"",
    xuekeCode:""
  }]);
  const [headerTeacherList, setHeaderTeacherList] = useState([{
    gradeName:"",
    gradeCode:""
  }]);
  const [otherStatus,setOtherStatus] = useState(false);
  const [otherText,setOtherText] = useState('');
  const [teacherXuekeInfo, setTeacherXuekeInfo] = useState({
    name: "",
    code: ""
  });
  const [teacherGradeInfo, setTeacherGradeInfo] = useState({
    name: "",
    code: ""
  })
  const [headerTeacherGradeInfo, setHeaderTeacherGradeInfo] = useState({
    name: "",
    code: ""
  });
  const [xuekeTeacherStatus,setXuekeTeacherStatus] = useState(false)
  const [headerTeacherStatus,setHeaderTeacherStatus] = useState(false)
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getXuekeList()
  }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function getXuekeList() {
    form.setFieldsValue({
      userName: props.user.name,
      login:props.user.user_login,
      // pwd:props.user.pwd,
      chushijifen:props.user.teacher_max_jifen,
      accountStatus:props.user.status==1,
      beizhu:props.user.beizhu
    })

    getXuekeListRequest(props.user.username, (data) => {
      if (data.ret == 1) {
        setGradeList(data.data.nianji_list);
        setXuekeList(data.data.xueke_list)


        let shenfenList = data.data.shenfen;
        var tempTeacherList = [];
        var tempHeaderTeacherList = [];
        var tempTeacherStatus = false;
        var tempHeaderTeacherStatus = false;
        shenfenList.map((item) => {
          if(item.type==1){
            tempTeacherStatus = true;
            setXuekeTeacherStatus(true)
            tempTeacherList.push({
              gradeName:item.nianji,
              gradeCode:item.nianji_code,
              xuekeName:item.xueke,
              xuekeCode:item.xueke_code,
            })
          }
          else if(item.type==2){
            tempHeaderTeacherStatus = true;
            setHeaderTeacherStatus(true)
            tempHeaderTeacherList.push({
              gradeName:item.nianji,
              gradeCode:item.nianji_code,
            })
          }
          else if(item.type==3){
            setOtherStatus(true)
            setOtherText(item.qita_content)
          }
        })
        if(tempTeacherStatus){
          setTeacherList(tempTeacherList)
        }
        else {
          setTeacherList([{
            gradeName:data.data.nianji_list[0].name,
            gradeCode:data.data.nianji_list[0].code,
            xuekeName:data.data.xueke_list[0].name,
            xuekeCode:data.data.xueke_list[0].code,
          }]);
        }
        if(tempHeaderTeacherStatus){
          setHeaderTeacherList(tempHeaderTeacherList)
        }
        else {
          let tempDic = {
            gradeName:data.data.nianji_list[0].name,
            gradeCode:data.data.nianji_list[0].code
          }
          console.log(data.data.nianji_list)
          setHeaderTeacherList([tempDic])
        }

      } else if (data.ret == 99) {
        messageApi.open({
          type: 'warning',
          content: data.msg
        });
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      }

    })
  }

  const onFinish = (values) => {
    var status = values.accountStatus==false?'0':'1';
    var teachershenfenArray = [];
    if (xuekeTeacherStatus==true) {
      teacherList.map((item) => {
        var shenfen = {
          "shenfen_type": 1,
          "nianji":item.gradeName,
          "nianji_code":item.gradeCode,
          "xueke":item.xuekeName,
          "xueke_code":item.xuekeCode,
          "status":status,
          "school":Cookies.get("school_code"),
        }
        teachershenfenArray.push(shenfen);
      })

    }
    if(headerTeacherStatus==true){
      headerTeacherList.map((item) => {
        var shenfen1 = {
          "shenfen_type": 2,
          "nianji":item.gradeName,
          "nianji_code":item.gradeCode,
          "status":status,
          "school":Cookies.get("school_code"),
        }
        teachershenfenArray.push(shenfen1);
      })
    }
    console.log(values)
    if(otherStatus==true){

      if(otherText.replaceAll(' ','').length==0){
        message.warning('请在其他中填写具体职业')
        return;
      }
      var shenfen2 = {
        "shenfen_type": 3,
        "status":status,
        "school":Cookies.get("school_code"),
        "qita_content":otherText
      }
      teachershenfenArray.push(shenfen2);
    }
    console.log(teachershenfenArray)
    if(teachershenfenArray.length==0){
      message.warning('请选择在校身份信息')
      return
    }


    // 这里可以添加API调用或其他提交逻辑
    updateSchoolTeacherRequest(
        values.userName,
        props.user.username,
        values.pwd==undefined||values.pwd==""?props.user.pwd:values.pwd,
        values.chushijifen,
        status,
        values.beizhu==undefined?"":values.beizhu,
        Cookies.get("school_code"),
        JSON.stringify(teachershenfenArray),
        (data)=>{
          if(data.ret == 1) {
            props.refreshList();
            closeCommon()
          }
          else {
            message.warning(data.msg);
          }
        }

    )
  };


  const closeCommon = () => {
    form.resetFields();
    props.closeCommonModal()
  };

  return (
      <Modal
          maskClosable={false}
          // visible={true}
          open={props.openStatus}
          onCancel={closeCommon}
          footer={null} // 设置 footer 为 null 移除默认按钮
          width={800}
          // className="add-account-container"
      >
        {contextHolder}
        <Card className={styles["form-card"]} span={20}>
          <div className={styles["form-title"]}>编辑账号</div>
          <Form
              form={form}
              layout="horizontal"
              onFinish={onFinish}
              className="account-form"
          >
            <Form.Item
                label="姓名"
                name="userName"
                rules={[{required: false, message: '请输入姓名'}]}
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <Input
                  placeholder={props.user.name}
                  size="large"
              />
            </Form.Item>
            <Form.Item
                label="账号(手机号)"
                name="login"
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <text>{props.user.user_login}</text>
            </Form.Item>
            <Form.Item
                label="登录密码"
                name="pwd"
                rules={[{required: false, message: '请输入登录密码'}]}
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <Input.Password
                  placeholder="请输入登录密码"
                  size="large"
              />
            </Form.Item>
            {/* <Form.Item
                label="账号积分初始限额"
                name="chushijifen"
                rules={[{required: false, message: '请输入账号积分配额'}]}
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <Input
                  placeholder={props.user.teacher_max_jifen}
                  size="large"
              />
              <text>{props.user.teacher_max_jifen}</text>
            </Form.Item> */}
            <Form.Item
                label="在校身份信息"
                name="shenfen"
                rules={[{required: false, message: '请输入在校身份信息'}]}
                labelAlign="right"
                labelCol={{span: 5}}
                valuePropName="checked"
            >
              <Row justify={"start"} align="middle">
                <Col span={5} >
                  <Checkbox
                      checked={xuekeTeacherStatus}
                      onChange={(e)=>{
                        setXuekeTeacherStatus(e.target.checked)
                      }}
                  >
                    学科教师
                  </Checkbox>
                </Col>
                <Col span={8} style={{marginRight:20}}>
                  <Select
                      options={
                        gradeList.map((item) => {
                          return {
                            value: item.code,
                            label: item.name
                          }
                        })
                      }
                      value={teacherList[0].gradeCode}
                      onChange={(value,item)=>{
                        var tempInfo = Object.assign(teacherList[0],{
                          gradeCode: item.value,
                          gradeName: item.label
                        });
                        var tempList = [...teacherList]
                        tempList[0]=tempInfo;
                        setTeacherList(tempList);
                      }}
                  />
                </Col>
                <Col span={8}>
                  <Select
                      options={
                        xuekeList.map((item) => {
                          return {
                            value: item.code,
                            label: item.name
                          }
                        })
                      }
                      value={teacherList[0].xuekeCode}
                      onChange={(value,item)=>{
                        var tempInfo = Object.assign(teacherList[0],{
                          xuekeCode: item.value,
                          xuekeName: item.label
                        });
                        var tempList = [...teacherList]
                        tempList[0]=tempInfo;
                        setTeacherList(tempList);
                      }}
                  />
                </Col>
                <Col span={1} style={{marginLeft:10}}>
                  <PlusOutlined
                      onClick={(e)=>{
                        var tempList = [...teacherList];
                        tempList.push({
                          gradeName:gradeList[0].name,
                          gradeCode:gradeList[0].code,
                          xuekeName:xuekeList[0].name,
                          xuekeCode:xuekeList[0].code
                        })
                        setTeacherList(tempList)
                      }}
                  />
                </Col>
              </Row>
            </Form.Item>
            {teacherList.map((item,index) => {
              if(index>0){
                return <Form.Item
                    label=" "
                    name="shenfen"
                    rules={[{required: false, message: '请输入账号积分配额'}]}
                    labelAlign="right"
                    labelCol={{span: 5}}
                    valuePropName="checked"
                    colon={false}
                >
                  <Row justify={"start"} align="middle">
                    <Col span={5} >
                    </Col>
                    <Col span={8} style={{marginRight:20}}>
                      <Select
                          options={
                            gradeList.map((item) => {
                              return {
                                value: item.code,
                                label: item.name
                              }
                            })
                          }
                          value={teacherList[index].gradeCode}
                          onChange={(value,item)=>{
                            var tempInfo = Object.assign(teacherList[index],{
                              gradeCode: item.value,
                              gradeName: item.label
                            });
                            var tempList = [...teacherList]
                            tempList[index]=tempInfo;
                            setTeacherList(tempList);
                          }}
                      />
                    </Col>
                    <Col span={8} >
                      <Select
                          options={
                            xuekeList.map((item) => {
                              return {
                                value: item.code,
                                label: item.name
                              }
                            })
                          }
                          value={teacherList[index].xuekeCode}
                          onChange={(value,item)=>{
                            var tempInfo = Object.assign(teacherList[index],{
                              xuekeCode: item.value,
                              xuekeName: item.label
                            });
                            var tempList = [...teacherList]
                            tempList[index]=tempInfo;
                            setTeacherList(tempList);
                          }}
                      />
                    </Col>
                    <Col span={1} style={{marginLeft:10}}>
                      <MinusOutlined
                          onClick={(e)=>{
                            var tempList = [...teacherList];
                            tempList.splice(index,1)
                            setTeacherList(tempList)
                          }}
                      />
                    </Col>
                  </Row>
                </Form.Item>
              }
            })}
            <Form.Item
                label=" "
                name="shenfen1"
                rules={[{required: false, message: '请输入账号积分配额'}]}
                labelAlign="right"
                labelCol={{span: 5}}
                valuePropName="checked"
                colon={false}
            >
              <Row justify={"start"} align="middle">
                <Col span={5} >
                  <Checkbox
                      checked={headerTeacherStatus}
                      onChange={(e)=>{
                        setHeaderTeacherStatus(e.target.checked)
                      }}
                  >
                    班主任
                  </Checkbox>
                </Col>
                <Col span={8} style={{marginRight:20}}>
                  <Select
                      options={
                        gradeList.map((item) => {
                          return {
                            value: item.code,
                            label: item.name
                          }
                        })
                      }
                      value={headerTeacherList[0].gradeCode}
                      onChange={(value,item)=>{
                        var tempInfo = Object.assign(headerTeacherList[0],{
                          gradeCode: item.value,
                          gradeName: item.label
                        });
                        var tempList = [...headerTeacherList]
                        tempList[0]=tempInfo;
                        setHeaderTeacherList(tempList);
                      }}

                  />
                </Col>
                <Col span={1} style={{marginLeft:10}}>
                  <PlusOutlined
                      onClick={(e)=>{
                        var tempList = [...headerTeacherList];
                        tempList.push({
                          gradeName:gradeList[0].name,
                          gradeCode:gradeList[0].code,
                        })
                        setHeaderTeacherList(tempList)
                      }}
                  />
                </Col>
              </Row>
            </Form.Item>
            {headerTeacherList.map((item,index) => {
              if(index>0){
                return <Form.Item
                    label=" "
                    name="shenfen"
                    rules={[{required: false, message: '请输入账号积分配额'}]}
                    labelAlign="right"
                    labelCol={{span: 5}}
                    valuePropName="checked"
                    colon={false}
                >
                  <Row justify={"start"} align="middle">
                    <Col span={5} >
                    </Col>
                    <Col span={8} style={{marginRight:20}}>
                      <Select
                          options={
                            gradeList.map((item) => {
                              return {
                                value: item.code,
                                label: item.name
                              }
                            })
                          }
                          value={headerTeacherList[index].gradeCode}
                          onChange={(value,item)=>{
                            var tempInfo = Object.assign(headerTeacherList[index],{
                              gradeCode: item.value,
                              gradeName: item.label
                            });
                            var tempList = [...headerTeacherList]
                            tempList[index]=tempInfo;
                            setHeaderTeacherList(tempList);
                          }}
                      />
                    </Col>
                    <Col span={1} style={{marginLeft:10}}>
                      <MinusOutlined
                          onClick={(e)=>{
                            var tempList = [...headerTeacherList];
                            tempList.splice(index,1)
                            setHeaderTeacherList(tempList)
                          }}
                      />
                    </Col>
                  </Row>
                </Form.Item>
              }
            })}
            <Form.Item
                label=" "
                name="shenfen2"
                rules={[{required: false, message: '请输入账号积分配额'}]}
                labelAlign="right"
                labelCol={{span: 5}}
                valuePropName="checked"
                colon={false}
            >
              <Row justify={"start"} align="middle">
                <Col span={5} >
                  <Checkbox
                      checked={otherStatus}
                      onChange={(e)=>{
                        setOtherStatus(e.target.checked)
                      }}
                  >
                    其他
                  </Checkbox>
                </Col>
                <Col span={8} style={{marginRight:20}}>
                  <Input
                      placeholder={otherText}
                      size="large"
                      onChange={(e)=>{
                        setOtherText(e.target.value);
                      }}
                  />
                </Col>
              </Row>
            </Form.Item>
            <Form.Item
                label="账号状态"
                name="accountStatus"
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <Switch
                  style={{marginLeft: 10, marginRight: 10}}
                  defaultChecked={props.user.status==1}
              />
            </Form.Item>
            <Form.Item
                label="备注"
                name="beizhu"
                labelAlign="right"
                labelCol={{span: 5}}
            >
              <TextArea
                  placeholder={props.user.beizhu}
                  onChange={(value) => {
                  }}
              />
            </Form.Item>
            <Form.Item className={styles["form-actions"]}>

              <Button

                  size="large"
                  // onClick={() => form.resetFields()}
                  onClick={(e)=>{
                    // props.cancel()
                    form.resetFields()
                    closeCommon()
                  }}
              >
                取消
              </Button>

              <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  style={{marginLeft: 16}}
              >
                确认
              </Button>

            </Form.Item>
          </Form>
        </Card>
      </Modal>
  );
};

export default EditAccountForm;

